import { useMemo } from 'react'
import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { getIntegrationServiceIdsForCategory, IntegrationCategory, IntegrationServiceId } from '../../common/integrations'
import { useGetMeQuery } from '../../store/user/user'

export const useIsMailIntegrationDisabled = (serviceId: IntegrationServiceId): boolean => {
  const accountId = useAppSelector(selectAccountId)
  const { data: userData } = useGetMeQuery({ accountId })

  return useMemo(() => {
    const mailIntegrationServiceIds = getIntegrationServiceIdsForCategory(IntegrationCategory.MAIL)
    if (serviceId === IntegrationServiceId.DELEGATED_EMAIL || !mailIntegrationServiceIds.includes(serviceId)) {
      return false
    }
    return !!(
      userData &&
      userData.integrations &&
      userData.integrations.some((i) => i.type === 'mail' && i.serviceId !== serviceId && i.serviceId !== IntegrationServiceId.DELEGATED_EMAIL)
    )
  }, [userData, serviceId])
}
